<div class="reset-pass">
  <div class="reset-pass__wrapper">
    <div class="reset-pass__container">
      <div class="reset-pass__left">
        <form
          (ngSubmit)="resetPass(resetPassForm)"
          #resetPassForm="ngForm"
          aria-labelledby="title"
          class="form"
        >
          <div class="form-group template full-width">
            <div id="pass" class="e-float-input" [ngClass]="{ 'e-success': password.valid }">
              <input
                type="password"
                id="input-password"
                name="password"
                [(ngModel)]="newPassword"
                #password="ngModel"
                required
                pattern="(?=.*[a-z])(?=.*[A-Z])[A-Za-z\d$@$!%#^*?&].{11,}"
              />
              <span class="e-float-line"></span>
              <label
                class="e-float-text"
                [ngClass]="{
                  'e-label-top': password !== '',
                  'e-label-bottom': password == ''
                }"
                for="name"
              >New Password</label>
              @if (!showPasswordFlag) {
                <mat-icon class="pass-icon" (click)="togglePassword('input-password')">visibility_off</mat-icon>
              }
              @if (showPasswordFlag) {
                <mat-icon class="pass-icon" (click)="togglePassword('input-password')">visibility</mat-icon>
              }
            </div>
            @if (password.invalid && password.touched) {
              @if (password.errors?.required) {
                <p class="caption status-danger">
                  Password is required!
                </p>
              }
              @if (password.dirty) {
                <p class="caption status-danger">
                  Password should contains minimum 12 characters, one lower case and one upper case.
                </p>
              }
            }
          </div>

          <div class="form-group template full-width">
            <div class="e-float-input" [ngClass]="{ 'e-success': password.valid }">
              <input
                type="password"
                id="input-re-password"
                name="rePass"
                [(ngModel)]="confirmPassword"
                #rePass="ngModel"
                required
                pattern="(?=.*[a-z])(?=.*[A-Z])[A-Za-z\d$@$!%#^*?&].{11,}"
              />
              <span class="e-float-line"></span>
              <label
                class="e-float-text"
                [ngClass]="{
                  'e-label-top': rePass !== '',
                  'e-label-bottom': rePass == ''
                }"
                for="name"
              >Confirm Password</label>
              @if (!showRePasswordFlag) {
                <mat-icon class="pass-icon" (click)="togglePassword('input-re-password')">visibility_off</mat-icon>
              }
              @if (showRePasswordFlag) {
                <mat-icon class="pass-icon" (click)="togglePassword('input-re-password')">visibility</mat-icon>
              }
            </div>
            @if (rePass.touched) {
              @if (rePass.invalid && rePass.errors?.required) {
                <p class="caption status-danger">
                  Password confirmation is required!
                </p>
              }
              @if (password.value != rePass.value && !rePass.errors?.required) {
                <p class="caption status-danger">
                  Password does not match the confirm password.
                </p>
              }
            }
          </div>

          <div class="form-group template center">
            <div class="submitBtn">
              <button
                style="width: 10vw"
                class="submit-btn e-btn"
                id="submit-btn"
                ejs-progressbutton
                content="Save Password"
                [enableProgress]="true"
                [spinSettings]="spinCenter"
                [animationSettings]="slideRight"
                cssClass="e-outline e-success"
                type="submit"
                [disabled]="submitted || !resetPassForm.valid || password.value != rePass.value"
              >
                Save Password
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="reset-pass__right">
        <section class="info-msg" aria-label="Reset Password">
          <div class="info-msg__title">Reset Your Password</div>
          <div class="info-msg__step">
            Enter your new password and confirm it to regain access to your account.
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
